import React from 'react'
import { StyledBox } from '../components/styledComponents/StyledItemComponents'
import { Box, Stack, Typography } from '@mui/material'
import { theme } from '../theme'

const Datelegale = () => {
  return (
    <Box sx={{ backgroundColor: theme.palette.secondary.main, paddingTop: '30px' }}>
    <StyledBox sx={{ padding: '50px 70px', backgroundColor: theme.palette.primary.main, minHeight: '50vh' }}>
    <Stack spacing={1}>
        <Typography variant='h5' sx={{ fontSize: '18px', paddingBottom: '20px' }}>PRIMUSVEST SRL</Typography>
        <Typography variant='h6' sx={{ fontSize: '16px', fontWeight: 400 }}><span style={{ fontWeight: 500 }}>Cod Unic de Înregistrare:</span> RO35750706</Typography>
        <Typography variant='h6' sx={{ fontSize: '16px', fontWeight: 400 }}><span style={{ fontWeight: 500 }}>Nr. Înmatriculare:</span> J05/485/2016</Typography>
        <Typography variant='h6' sx={{ fontSize: '16px', fontWeight: 400 }}><span style={{ fontWeight: 500 }}>Sediul social:</span> Sat Sârbești, nr. 72, cod poștal 417323, județul Bihor</Typography>
        <Typography variant='h6' sx={{ fontSize: '16px', fontWeight: 400 }}><span style={{ fontWeight: 500 }}>Magazine fizice:</span> Bulevardul Decebal 41, Oradea, jud. Bihor; str. Seleușului 117, Oradea, jud. Bihor</Typography>
        <Typography variant='h6' sx={{ fontSize: '16px', fontWeight: 400 }}><span style={{ fontWeight: 500 }}>Website:</span> www.primusvest.ro</Typography>
        <Typography variant='h6' sx={{ fontSize: '16px', fontWeight: 400 }}><span style={{ fontWeight: 500 }}>Email:</span> office@primusvest.ro</Typography>
        <Typography variant='h6' sx={{ fontSize: '16px', fontWeight: 400 }}><span style={{ fontWeight: 500 }}>Telefon:</span> +40 770 585 736</Typography>
      </Stack>
</StyledBox>
</Box>
  )
}

export default Datelegale
